import axios from 'axios';
import {
  SET_INTENTS_LOADING,
  SET_INTENTS_ERROR,
  FETCH_INTENTS_SUCCESS,
} from './type';

const BASE_URL = process.env.REACT_APP_PORT;

const head = {
  headers: {
    'x-auth-token': localStorage.getItem('token'),
  },
};

/**
 * Fetch intents for a domain (REAL_ESTATE, HEALTH_CARE, PRODUCT, E_COMMERCE, CONSTRUCTION, MARINE)
 * Stores result under state.intents.byDomain[domain] = { domain, items: [{key, description}, ...], fetchedAt }
 */
export const fetchIntentsByDomain = (domain) => async (dispatch, getState) => {
  if (!domain) return null;

  dispatch({ type: SET_INTENTS_LOADING });

  try {
    const res = await axios.get(`${BASE_URL}/api/ai/intent?domain=${encodeURIComponent(domain)}`, head);
    const doc = res?.data?.result;
    if (!doc || !doc.intents) {
      dispatch({ type: SET_INTENTS_ERROR, payload: `No intents for domain ${domain}` });
      return null;
    }

    // Flatten map to array [{ key, description }]
    const items = Object.entries(doc.intents).map(([key, v]) => ({
      key,
      description: v?.description || '',
    }));

    dispatch({
      type: FETCH_INTENTS_SUCCESS,
      payload: {
        domain: doc.domain || domain,
        items,
        fetchedAt: Date.now(),
      },
    });

    return items;
  } catch (err) {
    dispatch({ type: SET_INTENTS_ERROR, payload: err?.message || 'Failed to fetch intents' });
    return null;
  }
};
